// Gün Sonları Listesi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.endOfDayList';

export const endOfDayListGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Gün Sonları Listesi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Gün Sonu Raporu ekranında "Gün Sonu Yap" ile kaydedilmiş geçmiş gün sonlarını listeler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yenile ve Excel'),
    filters: t(`${G}.regions.filters`, 'Şube ve tarih'),
    table: t(`${G}.regions.table`, 'Gün sonu kayıtları'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama ve genel toplam'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Kayıtları getirin'),
      text: t(`${G}.s1.text`, 'Şube, Başlangıç ve Bitiş seçip "Filtrele"ye basın. Tarihler son 30 gün olarak gelir. Liste en yeni gün sonu en üstte olacak şekilde sıralanır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube olarak "Tümü" seçiliyse bütün kayıtlar gelir. Belirli bir şube seçerseniz yalnız o şube için yapılmış gün sonları görünür; tüm şubeler için yapılmış genel gün sonları bu durumda listede yer almaz.'),
        t(`${G}.s1.tip2`, 'Şube yöneticisi olarak girdiyseniz şube kendi şubenize kilitlidir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Sütunları okuyun'),
      text: t(`${G}.s2.text`, 'Her satır bir gün sonudur. Şube sütununda "Tümü" yazıyorsa gün sonu tüm şubeler (veya birden çok şube) için yapılmıştır. Tarih Aralığı gün sonunun kapsadığı başlangıç ve bitiş zamanıdır; Oluşturulma, gün sonunun yapıldığı andır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Nakit, POS ve Diğer: o gün sonunda kaydedilen ödeme türü toplamları.'),
        t(`${G}.s2.tip2`, 'İptal: aralıktaki iptal edilen satışların toplamı.'),
        t(`${G}.s2.tip3`, 'İşlem: iptal edilmeyen satış / sipariş sayısı.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Farkların anlamı'),
      text: t(`${G}.s3.text`, 'Bakiye, gün sonu yapılırken satış toplamından İptal toplamı düşülerek kaydedilir. Bu yüzden Nakit + POS + Diğer toplamı her zaman Bakiye\'ye eşit olmaz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Açık hesap ve ön ödemeli satışlar ile restoranda karma (parçalı) ödenen hesaplar ayrı sütunda tutulmaz; Bakiye\'de vardır ama Nakit, POS veya Diğer\'de görünmez. POS iadeleri Bakiye\'den düşülür.'),
        t(`${G}.s3.tip2`, 'Ödemesi alınmamış paket ve platform siparişleri Diğer sütununa ve Bakiye\'ye eklenir.'),
        t(`${G}.s3.tip3`, 'Rakamlar gün sonu anındaki durumdur; sonradan bir satış iptal edilse veya ödemesi alınsa bu liste değişmez.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s4.title`, '4. Yazdırın veya Excel\'e aktarın'),
      text: t(`${G}.s4.text`, 'Sağ üstteki Excel İndir düğmesi listedeki tüm kayıtları ve genel toplamı dosyaya yazar; dosyayı oradan yazdırabilirsiniz. Yenile listeyi aynı filtrelerle yeniden getirir. Bu listede satırlar yalnız görüntülenir; bir gün sonunun ayrıntılı dökümü için Gün Sonu Raporu ekranında aynı tarih aralığını filtreleyin.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Genel toplamı okuyun'),
      text: t(`${G}.s5.text`, 'Tablonun altında listelenen tüm raporların Toplam Bakiye, Toplam Nakit, Toplam POS, Toplam Diğer, Toplam İptal ve Toplam İşlem değerleri yer alır. Liste uzunsa sayfalamayla ilerleyin. Başlıktaki (i) bu rehberi açar.'),
    },
  ],
});
